import { api } from '../../service';

/**
 * Send push notification.
 *
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export const sendPushNotification = (values) => async () => {
  try {
    const { data } = await api.post('/push_notifications', values);

    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.general
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Send Sms notification.
 *
 * @param {object} values 
 * @returns 
 */
export const sendSmsNotification = (values) => async () => {
  try {
    const { data } = await api.post('/backoffice/sms', values);

    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
}

/**
 * Send WhatsApp message via Meta Business Cloud API (server-side, gated on
 * META_WA_TOKEN/META_WA_PHONE_NUMBER_ID being set). Returns 503 if not yet
 * configured; the BO surface still records the operator intent.
 *
 * @param {object} values
 * @returns
 */
export const sendWhatsappNotification = (values) => async () => {
  try {
    const { data } = await api.post('/backoffice/whatsapp', values);
    return data.data;
  } catch (error) {
    const message = error.response
      ? (error.response.data.moreInformation && error.response.data.moreInformation.error) ||
        error.response.data.codeDetail ||
        error.message
      : error.message;
    // eslint-disable-next-line no-alert
    window.alert('WhatsApp send: ' + message);
    throw new Error(message);
  }
};